import * as React from 'react';
import './ActionsDac.scss';
import {DacState, ServicesState, SitesState} from "../../../Store/Reducers/Dac/types";
import {connect, ConnectedProps} from "react-redux";
import {
    addService,
    addSite,
    duplicateSites,
    editDac,
    editError,
    editSites,
    editSociety,
    pasteServices,
    removeServices,
    removeSites,
    setDAC
} from "../../../Store/Reducers/Dac/actions";
import Socket from "../../../utils/Socket/Socket";
import {notification, Tooltip, InputNumber, Popover, Modal, Select, Progress, message, Upload, Button} from "antd";
import User from "../../../utils/User/User";
import {faSave} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ActionsDacState} from "../../../Store/Reducers/Dac/ActionsDac/types";
import {editActionsDac} from "../../../Store/Reducers/Dac/ActionsDac/actions";
import {TotalState} from "../../../Store/Reducers/Dac/Total/types";
import {editTotal, receiveTotal} from "../../../Store/Reducers/Dac/Total/actions";
import PDFButton from "../PDF/PDFButton";
import axios from "axios";
import TotalFunctions from "./Total/Functions/TotalFunctions";
import SelectSearch from "../../Input/SelectSearch/SelectSearch";
import IconDelete from "../../IconSVG/IconDelete";
import IconDuplicate from "../../IconSVG/IconDuplicate";
import IconAdd from "../../IconSVG/IconAdd";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
const { Option, OptGroup } = Select;

//
// const bdcKey = '9c6420bf0e752e05c2b2c3e9165bfa36db65cfe0';

interface RootState {
    dacReducer: DacState,
    actionsDacReducer: ActionsDacState,
    totalReducer: TotalState,
    collectionsReducer: any,
}

const mapState = (state: RootState, ownProps: any) => ({
    dacReducer: state.dacReducer,
    dac_society_reducer: state.dacReducer.society,
    sitesReducer: state.dacReducer.sites,
    selectedSites: state.actionsDacReducer.copySites,
    selectedServices: state.actionsDacReducer.copyServices,
    totalReducer: state.totalReducer,
    discount_abo: state.totalReducer.discount_abo,
    discount_fas: state.totalReducer.discount_fas,
    serviceCollectionsReducer: state.collectionsReducer.Service || [],
    categoryReducer: state.collectionsReducer.Category || [],
});

const mapDispatch = {
    addSite: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => addSite(),
    addService: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, ids: Array<string>) => addService(ids),
    editError: (section: string, key: string, value: string, nbSite: number, nbService: number) => editError(section, key, value, nbSite, nbService),
    removeSites: (ids: Array<string>) => removeSites(ids),
    removeServices: (ids: Array<{ idSite: string, idService: string }>) => removeServices(ids),
    clearSelected: (name: string, selected: Array<string>) => editActionsDac(name, selected),
    duplicateSites: (sites: Array<SitesState>) => duplicateSites(sites),
    duplicateServices: (services: Array<ServicesState>, sites: Array<string>) => pasteServices(services, sites),
    editSociety: (name: string, value: number | string) => editSociety(name, value),
    editTotal: (name: string, value: number) => editTotal(name, value),
    receiveTotal: (value: TotalState) => receiveTotal(value),
    editSites: (name: string, value: string | number, nbSite: number) => editSites(name, value, nbSite),
    editDac: (nb: number) => editDac('countServices', nb),
    pushCopyServices: (name: string, value: Array<{ idSite: string, idService: string }>) => editActionsDac(name, value),
    setDAC: (value: DacState) => setDAC(value),
    editServiceInput: (name: string, value: any) => editSites(name, value, 0),
    editServiceObject: (service: any, siteId: string, serviceIndex: number) => editActionsDac('services', {
        [siteId]: {
            [serviceIndex]: service
        }
    })
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    serviceCollectionsReducer: ServiceOption[];
    categoryReducer: any[];
    durations: Array<{ label: string, id: string }>
}

interface BatchProcessingState {
    isProcessing: boolean;
    progress: number;
    currentOperation: string;
}

interface State {
    disabledPdf: boolean,
    subscribe_duration: string,
    change: boolean,
    crashTest: Array<any>,
    pa_fas_total: number,
    pa_abo_total: number,
    numberOfSites: number,
    showSiteCreationPopover: boolean,
    batchProcessing: BatchProcessingState;
    selectedServices: string[];
    showBatchServiceModal: boolean;
}

interface ServiceOption {
    id_service: string;
    designation: string;
    id_categorie: string;
    frn: string;
    abo_ht: number;
    fas_ht: number;
    duration: string;
    quantity: number;
    describe_solution: string;
}

interface ExcelSiteData {
    site_name: string;
    contact_name: string;
    contact_tel: string;
    contact_mail: string;
    delivery_address: string;
    siret: string;
    solution: string;
    abo_ht: string;
    fas_ht: string;
    quantity: string;
    status: string;
    new_service: string;
    existing_service: string;
    replace_service: string;
    upgrade_service: string;
}

class ActionsDac extends React.Component<Props, State> {
    // Add a class property to track mounted state
    private _isMounted: boolean = false;

    constructor(props: any) {
        super(props);
        this.state = {
            disabledPdf: true,
            subscribe_duration: "",
            change: false,
            crashTest: ['re', 're'],
            pa_fas_total: 0,
            pa_abo_total: 0,
            numberOfSites: 1,
            showSiteCreationPopover: false,
            batchProcessing: {
                isProcessing: false,
                progress: 0,
                currentOperation: ''
            },
            selectedServices: [],
            showBatchServiceModal: false,
        }
    }

    async getIdDurationPipe(duration: string) {
        try {
            const res = await axios.get('https://api.pipedrive.com/v1/dealFields/12465?api_token=92a31b515d71bcff39efa003d56b2978f2658e6e');
            //@ts-ignore
            return res.data.data.options.find(item => parseInt(item.label) === parseInt(duration)).id;
        } catch (e) {
            console.error(e)
            return;
        }
    }


    checkError = () => {
        let error = false;
        const requiredInputs = document.querySelectorAll('[data-required="true"]');
        requiredInputs.forEach(element => {
            const value = element.getAttribute('data-value') ? element.getAttribute('data-value') : element.value;
            if (!value) {
                element.classList.add('error__Field')
            }
        })
        return error;
    }

    saveQuote = () => {
        const { dacReducer } = this.props;

        // 1. Calculate totals by summing site totals (not individual services)
        const abo_ht = dacReducer.sites.reduce((sum, site) => sum + (site.abo_ht || 0), 0);
        const fas_ht = dacReducer.sites.reduce((sum, site) => sum + (site.fas_ht || 0), 0);
        
        // 2. For upgrade totals and margins, still use all services for complete calculation
        const allServices = this.flatRecursive(dacReducer.sites, 'services', []);
        
        // 3. Calculate upgrade totals (all values including negative)
        const abo_upgrade = allServices.reduce((sum, s) => sum + (s.abo_ht || 0), 0);
        const fas_upgrade = allServices.reduce((sum, s) => sum + (s.fas_ht || 0), 0);
        
        // 4. Calculate margin totals (positive values only for BCA and BCF)
        const mge_abo = allServices.reduce((sum, s) => sum + Math.max(0, s.mge_abo || 0), 0);
        const mge_fas = allServices.reduce((sum, s) => sum + Math.max(0, s.mge_fas || 0), 0);

        // 5. Build updatedDacReducer with correct society totals
        const updatedDacReducer = {
            ...dacReducer,
            sites: dacReducer.sites.map(site => ({
                ...site,
                services: site.services.map(service => ({
                    ...service,
                    status: service.status || 'new',
                    notice_period: service.notice_period || 0
                }))
            })),
            society: {
                ...dacReducer.society,
                abo_ht,
                fas_ht,
                mge_abo,
                mge_fas,
                abo_upgrade,
                fas_upgrade,
            }
        };

        console.log("SOCIETY", updatedDacReducer.society);

        if (!this.checkError()) {
            Socket.read('Order', {['society.id_order']: updatedDacReducer.society.id_order})
                .then(res => {
                    if (res.data.length > 0) {
                        Socket.update('Order', res.data[0]._id, null, updatedDacReducer)
                            .then(res => {
                                if (res.status === 200) {
                                    notification.success({message: "Votre devis a bien été mis a jour. Retrouvez le dans l'historique."});
                                    axios.put(`https://api.pipedrive.com/v1/deals/${updatedDacReducer.society.id_pipedrive}?api_token=92a31b515d71bcff39efa003d56b2978f2658e6e`,
                                        {
                                            '9c6420bf0e752e05c2b2c3e9165bfa36db65cfe0': updatedDacReducer.society.id_order,
                                            "d3a396fe2f9e8d79b7b478645e0c598a05798c9f": parseInt(updatedDacReducer.society.subscribe_duration),
                                            "07202d8e78c6626b26b986eaa4c61d7a53188a73": updatedDacReducer.society.fas_ht,
                                            "5218646ecb703b444ec78d1f7d6b79d17a8bc72c": updatedDacReducer.society.mge_fas,
                                            "value": updatedDacReducer.society.abo_ht,
                                            "6505fba293d443baf594b1bcb941aa9a8fba5dc7": updatedDacReducer.society.mge_abo,
                                            "b1731c98a2b11a194b4f9fe0ec53dd10be41f193": updatedDacReducer.society.abo_upgrade,
                                            "currency": "EUR",
                                            "07202d8e78c6626b26b986eaa4c61d7a53188a73_currency": "EUR",
                                            "6505fba293d443baf594b1bcb941aa9a8fba5dc7_currency": "EUR",
                                            "5218646ecb703b444ec78d1f7d6b79d17a8bc72c_currency": "EUR",
                                        },
                                        {
                                            "headers": {
                                                "Content-Type": "application/json"
                                            }
                                        })
                                        .then(res => {
                                            localStorage.removeItem('dac')
                                            // this.props.setDAC(dacState);
                                        }).catch(err => console.error(err))
                                } else {
                                    console.error(res);
                                    notification.error({message: "Une erreur est survenu lors de la mise a jour."})
                                }
                            })
                    } else {
                        Socket.insert('Order', updatedDacReducer)
                            .then(res => {
                                notification.success({message: "Votre devis a bien été sauvegardé. Retrouvez le dans l'historique."});

                                User.userInfo()
                                    .then(user => {
                                        const quoteType = updatedDacReducer.billing.contract ? "contrat" : "devis";
                                        const title = `Nouveau ${quoteType}`;
                                        const message = `ID: ${updatedDacReducer.society.id_pipedrive} | Deal: ${updatedDacReducer.society.title}`;
                                        const details = `${user.firstname} ${user.lastname} à créer un ${quoteType} pour le deal ${updatedDacReducer.society.title}`;
                                        Socket.insert("ToolitLogs", {title, message, details})
                                            .catch(err => console.error(err))
                                        Socket.sendNotif({title, message, details});
                                        axios.put(`https://api.pipedrive.com/v1/deals/${updatedDacReducer.society.id_pipedrive}?api_token=92a31b515d71bcff39efa003d56b2978f2658e6e`,
                                            {
                                                '9c6420bf0e752e05c2b2c3e9165bfa36db65cfe0': updatedDacReducer.society.id_order,
                                                "d3a396fe2f9e8d79b7b478645e0c598a05798c9f": parseInt(updatedDacReducer.society.subscribe_duration),
                                                "07202d8e78c6626b26b986eaa4c61d7a53188a73": updatedDacReducer.society.fas_ht,
                                                "5218646ecb703b444ec78d1f7d6b79d17a8bc72c": updatedDacReducer.society.mge_fas, // BCF - positive fas margins only
                                                "value": updatedDacReducer.society.abo_ht,
                                                "6505fba293d443baf594b1bcb941aa9a8fba5dc7": updatedDacReducer.society.mge_abo, // BCA - positive abo margins only
                                                "b1731c98a2b11a194b4f9fe0ec53dd10be41f193": updatedDacReducer.society.abo_upgrade,
                                                "currency": "EUR",
                                                "07202d8e78c6626b26b986eaa4c61d7a53188a73_currency": "EUR",
                                                "6505fba293d443baf594b1bcb941aa9a8fba5dc7_currency": "EUR",
                                                "5218646ecb703b444ec78d1f7d6b79d17a8bc72c_currency": "EUR",
                                            },
                                            {
                                                "headers": {
                                                    "Content-Type": "application/json"
                                                }
                                            })
                                            .then(res => {
                                                // this.props.setDAC(dacState);
                                                localStorage.removeItem('dac')
                                            }).catch(err => console.error(err))
                                    });
                                this.setState(() => ({disabledPdf: false}))
                            })
                            .catch(err => {
                                console.error(err)
                                notification.error({message: "Une erreur est survenu lors de l'enregistrement."})
                            })
                    }
                })
                .catch(err => console.error(err))
        } else {
            notification.error({message: "Une erreur est survenu lors de l'enregistrement."});
        }
    };

    removeSites = () => {
        const {selectedSites} = this.props;
        this.props.removeSites(selectedSites);
        this.props.clearSelected('copySites', []);
    }

    removeServices = () => {
        const {selectedServices} = this.props;
        if (selectedServices.length > 0) {
            this.props.removeServices(selectedServices);
            this.props.clearSelected('copyServices', []);
        }
    }

    saveIfError = async () => {
        const {id_pipedrive} = this.props.dacReducer.society;
        if (id_pipedrive) {
            let res = await Socket.readLean('SaveCrashToolit', {'society.id_pipedrive': id_pipedrive}, {});
            if (res.data.length > 0) {
                Socket.update('SaveCrashToolit', res.data[0]._id, null, this.props.dacReducer);
            } else {
                Socket.insert('SaveCrashToolit', this.props.dacReducer)
            }
        }
    }


    componentDidMount() {
        this._isMounted = true;
        this.dispatchFinalTotal();

        const services = this.flatRecursive(this.props.sitesReducer, 'services', []);


        const findDuration = Math.max(...services.map(s => Number.isInteger(parseInt(s.duration == 37 ? 0 : s.duration)) ? parseInt(s.duration == 37 ? 0 : s.duration) : 0))
        const duration = findDuration == 0 ? `37` : `${findDuration}`;
        const pa_abo_total = services.reduce((a, c) => a + (c.pa_abo || 0), 0);
        const pa_fas_total = services.reduce((a, c) => a + (c.pa_fas || 0), 0);
        const mge_abo_total = services.reduce((a, c) => a + (c.mge_abo || 0), 0);
        const mge_fas_total = services.reduce((a, c) => a + (c.mge_fas || 0), 0);
        this.setState(prevState => ({...prevState, subscribe_duration: duration, pa_abo_total, pa_fas_total, mge_abo_total, mge_fas_total}));
        TotalFunctions.calcPrice(this.props)
        this.props.editDac(this.countServices());

        if (this.props.dacReducer.society.subscribe_duration) {
            this.setState(() => ({
                subscribe_duration: this.props.dacReducer.society.subscribe_duration
            }))
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.saveIfError()
        this.props.clearSelected('copySites', []);
        this.props.clearSelected('copyServices', []);
    }

    componentDidCatch(error: any, errorInfo: any) {
        // Vous pouvez aussi enregistrer l'erreur au sein d'un service de rapport.

    }

    flatRecursive = (a: Array<any>, searchKey: string, t: Array<any>) => {
        if (Array.isArray(a)) {
            for (let i = 0; i < a.length; i++) {
                if (typeof a[i] === "object" && !Array.isArray(a[i])) {
                    for (let [key, value] of Object.entries(a[i])) {
                        if (key === searchKey) {
                            // Ensure value is an array before spreading
                            if (value) {
                                const arrayValue = Array.isArray(value) ? value : [value];
                                if (arrayValue.length > 0) {
                                    const clonedValue = arrayValue.map(x => ({...x}));
                                    t.push(...clonedValue);
                                }
                            }
                        }
                        if (typeof value === "object" && value) {
                            this.flatRecursive(value, searchKey, t);
                        }
                    }
                }
            }
        }
        return t;
    };

    dispatchFinalTotal = () => {
        const {discount_abo, discount_fas, mge_abo, mge_fas, tx_abo, tx_fas, abo_ht, fas_ht, aboUpgrade, fasUpgrade} = this.props.totalReducer;
        const keys = {
            discount_abo: discount_abo,
            discount_fas: discount_fas,
            mge_abo: mge_abo, // Now contains positive-only values
            mge_fas: mge_fas, // Now contains positive-only values
            tx_abo: this.margeTaux('abo'),
            tx_fas: this.margeTaux('fas'),
            abo_ht: this.prixVenteTotal('abo'),
            fas_ht: this.prixVenteTotal('fas'),
            aboUpgrade: aboUpgrade,
            fasUpgrade: fasUpgrade,
        };
        for (let [key, value] of Object.entries(keys)) {
            this.props.editSociety(key, value);
        }
    }

    countServices() {
        let countServices = 0;
        for (let {quantity} of this.props.sitesReducer.flatMap(s => s.services)) {
            countServices += quantity;
        }
        return countServices;
    }

    deselectServicesRemove(services: Array<string>) {
        return this.props.selectedServices.filter(s => services.includes(s.idService));
    }

    checkChangeServices(prevSites: Array<SitesState>, sites: Array<SitesState>) {
        const prevServices = prevSites.flatMap((s: any) => s.services);
        const services = sites.flatMap((s: any) => s.services);
        if (JSON.stringify(prevServices) !== JSON.stringify(services)) {
            TotalFunctions.calcPrice(this.props)
            this.props.editDac(this.countServices());
            const newServicesSelected = this.deselectServicesRemove(services.flatMap((service => service.id)));
            this.props.pushCopyServices('copyServices', newServicesSelected)
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.totalReducer !== this.props.totalReducer) {
            this.dispatchFinalTotal();
        }
        if (prevProps.sitesReducer !== this.props.sitesReducer) {
            this.checkChangeServices(prevProps.sitesReducer, this.props.sitesReducer);
            const services = this.flatRecursive(this.props.sitesReducer, 'services', []);
            const findDuration = Math.max(...services.map(s => Number.isInteger(parseInt(s.duration == 37 ? 0 : s.duration)) ? parseInt(s.duration == 37 ? 0 : s.duration) : 0))
            const duration = findDuration == 0 ? `37` : `${findDuration}`;
            const pa_abo_total = services.reduce((a, c) => a + (c.pa_abo || 0), 0);
            const pa_fas_total = services.reduce((a, c) => a + (c.pa_fas || 0), 0);
            const mge_abo_total = services.reduce((a, c) => a + (c.mge_abo || 0), 0);
            const mge_fas_total = services.reduce((a, c) => a + (c.mge_fas || 0), 0);
            this.setState(prevState => ({...prevState, subscribe_duration: duration, pa_abo_total, pa_fas_total, mge_abo_total, mge_fas_total}));
        }
        if (prevProps.sitesReducer.length !== this.props.sitesReducer.length) {
            this.saveIfError();
        }
        if (this.state.subscribe_duration !== prevState.subscribe_duration) {
            this.props.editSociety('subscribe_duration', this.state.subscribe_duration);
        }
    }

    duplicateSites = () => {
        const {selectedSites, sitesReducer} = this.props;
        const sites = sitesReducer.filter(s => selectedSites.includes(s._id));
        this.props.duplicateSites(sites);
    }

    duplicateServices = () => {
        const {selectedServices, selectedSites, sitesReducer} = this.props;
        const allServices = this.flatRecursive(sitesReducer, "services", []);
        const services = allServices.filter(s => Array.from(selectedServices, o => o.idService).includes(s.id));
        this.props.duplicateServices(services, selectedSites);
    }

    editDiscount = (event: React.ChangeEvent<HTMLInputElement>) => {
        let {name, value} = event.target;
        value = (value) ? value : "0";
        this.props.editTotal(name, parseFloat(value))
    }

    crash = () => {
        //@ts-ignore
        this.setState(state => ({crashTest: ''}));
    }

    // margeTaux = (unit: string) => {
    //     // @ts-ignore
    //     const prixVente = this.props.totalReducer[`${unit}_ht`];
    //     // @ts-ignore
    //     let mge = (prixVente * ((100 - this.props.dac_society_reducer[`discount_${unit}`]) / 100)) - this.state[`pa_${unit}_total`];
    //     // @ts-ignore
    //     return parseFloat(`${(mge / prixVente)}`).toFixed(2);
    // }

    renderMarge = (unit: string) => {
        // @ts-ignore
        const prixVente = this.props.totalReducer[`${unit}_ht`];
        // @ts-ignore
        return parseFloat((prixVente * ((100 - this.props.dac_society_reducer[`discount_${unit}`]) / 100)) - this.state[`pa_${unit}_total`]).toFixed(2);
    }


    prixVenteTotal = (unit: string) => {

        //@ts-ignore
        const price = this.discountMultiplicator(unit) * this.props.totalReducer[`${unit}_ht`];
        return price
    }

    prixAchatTotal = (unit: string) => {
        //@ts-ignore
        const price = this.state[`pa_${unit}_total`];
        return price;
    }

    margeTotal = (unit: string) => {
        const marge = this.prixVenteTotal(unit) - this.prixAchatTotal(unit);
        return marge;

    }

    discountMultiplicator = (unit: string) => {
        //@ts-ignore
        const discount = this.props.dac_society_reducer[`discount_${unit}`];
        const nDiscount = discount ? discount : 0;
        return (100 - nDiscount) / 100;
    }


    margeTaux = (unit: string) => {
        const tauxMarge = (this.margeTotal(unit) / this.prixVenteTotal(unit)) * 100;
        return tauxMarge ? tauxMarge : 0;

    }

    handleNumberOfSitesChange = (value: number | null) => {
        this.setState({ numberOfSites: value || 1 });
    };

    handleBatchCreation = async () => {
        const { numberOfSites } = this.state;
        const BATCH_SIZE = 10; // Process 10 sites at a time
        
        this.setState({ 
            batchProcessing: {
                isProcessing: true,
                progress: 0,
                currentOperation: 'Creating sites...'
            }
        });

        try {
            // Create sites in batches
            for (let i = 0; i < numberOfSites; i += BATCH_SIZE) {
                const batchCount = Math.min(BATCH_SIZE, numberOfSites - i);
                const promises = Array(batchCount).fill(null).map(() => this.props.addSite({}));
                await Promise.all(promises);

                const progress = Math.round(((i + batchCount) / numberOfSites) * 100);
                this.setState(prev => ({
                    batchProcessing: {
                        ...prev.batchProcessing,
                        progress,
                    }
                }));
            }

            // Show service selection modal after sites are created
            this.setState({ 
                showBatchServiceModal: true,
                showSiteCreationPopover: false,
                batchProcessing: {
                    isProcessing: false,
                    progress: 100,
                    currentOperation: 'Sites created successfully!'
                }
            });

        } catch (error) {
            console.error('Batch creation failed:', error);
            message.error('Failed to create sites. Please try again.');
            this.setState(prev => ({
                batchProcessing: {
                    ...prev.batchProcessing,
                    isProcessing: false,
                }
            }));
        }
    };

    findServiceByName = (solutionName: string, serviceCollections: any) => {
        const service = serviceCollections.find((s: any) => 
            s.designation.trim() === solutionName.trim()
        );
        if (service) {
            return service;
        }
        return null;
    };

    findServiceInCategories = (serviceId: string, serviceCollections: any) => {
        const service = serviceCollections.find((s: any) => s.id_service === serviceId);
        if (service) {
            return service;
        }
        return null;
    };


    handleBatchServiceAssignment = async () => {
        const { selectedServices } = this.state;
        const { sitesReducer, serviceCollectionsReducer } = this.props;

        if (!selectedServices || selectedServices.length === 0) {
            message.warning('Veuillez sélectionner au moins un service');
            return;
        }

        this.setState({
            batchProcessing: {
                isProcessing: true,
                progress: 0,
                currentOperation: 'Attribution des services...'
            }
        });

        try {
            const { numberOfSites } = this.state;
            const newSiteIds = sitesReducer.slice(-numberOfSites).map(site => site._id);

            newSiteIds.forEach(siteId => {
                const servicesInSite = sitesReducer
                    .find(site => site._id === siteId)
                    ?.services
                    .map(service => ({ idSite: siteId, idService: service.id })) || [];
                
                if (servicesInSite.length > 0) {
                    this.props.removeServices(servicesInSite);
                }
            });

            const serviceTemplates = selectedServices
                .map(serviceId => this.findServiceInCategories(serviceId, serviceCollectionsReducer))
                .filter(Boolean)
                .map(template => ({
                    ...template,
                    quantity: 1,
                    duration: "24",
                    status: "new" // Explicitly set status for new services
                }));

            await this.props.duplicateServices(serviceTemplates, newSiteIds);
            
            // Force a save to ensure the status is stored in the DacReducer
            this.saveIfError();

            this.setState({
                batchProcessing: {
                    isProcessing: false,
                    progress: 100,
                    currentOperation: ''
                },
                showBatchServiceModal: false
            });

            message.success(`Services attribués avec succès à ${numberOfSites} sites`);

        } catch (error) {
            console.error('Échec de l\'attribution des services:', error);
            message.error('Échec de l\'attribution des services');
            this.setState({
                batchProcessing: {
                    isProcessing: false,
                    progress: 0,
                    currentOperation: ''
                }
            });
        }
    };

    handleServiceSelection = (values: string[]) => {
        this.setState({ selectedServices: values });
    };

    renderBatchProcessingModal() {
        const { batchProcessing } = this.state;

        return (
            <Modal
                title=""
                open={batchProcessing.isProcessing}
                footer={null}
                closable={false}
            >
                <div className="batch-processing-modal">
                    <h3>{batchProcessing.currentOperation}</h3>
                    <Progress percent={batchProcessing.progress} status="active" />
                </div>
            </Modal>
        );
    }

    renderServiceSelectionModal() {
        const { showBatchServiceModal, selectedServices } = this.state;
        const { serviceCollectionsReducer, categoryReducer } = this.props;

        if (!serviceCollectionsReducer || !categoryReducer) {
            return (
                <Modal
                    title="Sélectionnez les services pour tous les sites"
                    open={showBatchServiceModal}
                    onOk={() => this.setState({ showBatchServiceModal: false })}
                    onCancel={() => this.setState({ showBatchServiceModal: false })}
                >
                    <div>Loading services...</div>
                </Modal>
            );
        }

        const groupedServices = serviceCollectionsReducer.reduce((acc: any, service: ServiceOption) => {
            const category = categoryReducer.find((cat: any) => cat._id === service.id_categorie);
            const categoryName = category ? category.name : 'Other';
            
            if (!acc[categoryName]) {
                acc[categoryName] = [];
            }
            acc[categoryName].push(service);
            return acc;
        }, {});

        return (
            <Modal
                title="Sélectionnez les services pour tous les sites"
                open={showBatchServiceModal}
                onOk={this.handleBatchServiceAssignment}
                onCancel={() => this.setState({ showBatchServiceModal: false })}
                width={800}
                okText="Attribuer les services"
                cancelText="Annuler"
            >
                <div className="service-selection">
                    {Object.keys(groupedServices).length === 0 ? (
                        <div>Aucun service disponible</div>
                    ) : (
                        <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Sélectionnez les services à ajouter à tous les sites"
                            value={this.state.selectedServices}
                            onChange={this.handleServiceSelection}
                            optionFilterProp="children"
                            optionLabelProp="label"
                        >
                            {Object.entries(groupedServices).map(([category, services]: [string, any[]]) => (
                                <Select.OptGroup key={category} label={category}>
                                    {services.map((service: ServiceOption) => (
                                        <Select.Option 
                                            key={service.id_service}
                                            value={service.id_service}
                                            label={service.designation}
                                        >
                                            <div className="service-option">
                                                <span>{service.designation}</span>
                                                <span className="service-details">
                                                    {`ABO: ${service.abo_ht}€ | FAS: ${service.fas_ht}€`}
                                                </span>
                                            </div>
                                        </Select.Option>
                                    ))}
                                </Select.OptGroup>
                            ))}
                        </Select>
                    )}
                </div>
            </Modal>
        );
    }

    handleAddMultipleSites = () => {
        const { numberOfSites } = this.state;
        if (numberOfSites > 10) {
            // Use batch processing for large numbers
            this.handleBatchCreation();
        } else {
            // Use existing method for small numbers
            for (let i = 0; i < numberOfSites; i++) {
                this.props.addSite({});
            }
            this.setState({ showSiteCreationPopover: false });
        }
    };

    handleExcelUpload = async (file: File) => {
        this.setState({
            batchProcessing: {
                isProcessing: true,
                progress: 0,
                currentOperation: 'Lecture du fichier Excel...'
            }
        });

        try {
            const data = await this.readExcelFile(file);
            await this.processExcelData(data);

            this.setState({
                batchProcessing: {
                    isProcessing: false,
                    progress: 100,
                    currentOperation: ''
                }
            });

            message.success('Sites et services créés avec succès');
        } catch (error) {
            console.error('Erreur lors du traitement du fichier:', error);
            message.error('Erreur lors du traitement du fichier Excel');
            this.setState({
                batchProcessing: {
                    isProcessing: false,
                    progress: 0,
                    currentOperation: ''
                }
            });
        }
    };

    readExcelFile = (file: File): Promise<ExcelSiteData[]> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const workbook = XLSX.read(e.target?.result, { type: 'binary' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const data = XLSX.utils.sheet_to_json(worksheet);
                    
                    // Transform data to match ExcelSiteData structure
                    const formattedData: ExcelSiteData[] = data.map((row: any) => ({
                        site_name: row.site_name || '',
                        contact_name: row.contact_name || '',
                        contact_tel: row.contact_tel || '',
                        contact_mail: row.contact_mail || '',
                        delivery_address: row.delivery_address || '',
                        siret: row.siret || '',
                        solution: row.solution || '',
                        abo_ht: row.abo_ht || '',
                        fas_ht: row.fas_ht || '',
                        quantity: row.quantity || '1',
                        status: row.status || '',
                        new_service: row.new_service || '',
                        existing_service: row.existing_service || '',
                        replace_service: row.replace_service || '',
                        upgrade_service: row.upgrade_service || ''
                    }));

                    resolve(formattedData);
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsBinaryString(file);
        });
    };

    processExcelData = async (data: ExcelSiteData[]) => {
        const { serviceCollectionsReducer } = this.props;
        
        // Group data by site_name to handle multiple services per site
        const siteGroups = data.reduce((acc: { [key: string]: ExcelSiteData[] }, row) => {
            if (!acc[row.site_name]) {
                acc[row.site_name] = [];
            }
            acc[row.site_name].push(row);
            return acc;
        }, {});

        let processedCount = 0;
        const totalSites = Object.keys(siteGroups).length;

        for (const [siteName, siteData] of Object.entries(siteGroups)) {
            // Use first row for site details
            const siteDetails = siteData[0];
            
            // Create site and wait for it to be available in reducer
            await this.props.addSite({});
            
            // Wait a moment for the reducer to update
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Get the newly created site's ID and index
            const siteIndex = this.props.sitesReducer.length - 1;
            const newSiteId = this.props.sitesReducer[siteIndex]._id;
            
            // Remove the default empty service that gets created with the site
            const site = this.props.sitesReducer.find(site => site._id === newSiteId);
            if (site && site.services && site.services.length > 0) {
                const servicesInSite = site.services.map(service => ({
                    idSite: newSiteId,
                    idService: service.id
                }));
                await this.props.removeServices(servicesInSite);
            }
            
            // Update site information
            await Promise.all([
                this.props.editSites('site_name', siteDetails.site_name, siteIndex),
                this.props.editSites('contact_name', siteDetails.contact_name, siteIndex),
                this.props.editSites('contact_tel', siteDetails.contact_tel, siteIndex),
                this.props.editSites('contact_mail', siteDetails.contact_mail, siteIndex),
                this.props.editSites('delivery_address', siteDetails.delivery_address, siteIndex),
                this.props.editSites('siret', siteDetails.siret, siteIndex)
            ]);

            const serviceTemplates = [];
            for (const row of siteData) {
                if (row.solution) {
                    const serviceTemplate = this.findServiceByName(row.solution, serviceCollectionsReducer);
                    if (serviceTemplate) {
                        // Determine status based on which status column has an X
                        let statusValue = 'new'; // Default
                        
                        // Check the X-marked columns first (case insensitive)
                        if (row.existing_service && ['x', 'X', '✓', '✔'].includes(row.existing_service.toString().trim())) {
                            statusValue = 'existing';
                        } else if (row.replace_service && ['x', 'X', '✓', '✔'].includes(row.replace_service.toString().trim())) {
                            statusValue = 'replace';
                        } else if (row.new_service && ['x', 'X', '✓', '✔'].includes(row.new_service.toString().trim())) {
                            statusValue = 'new';
                        } else if (row.upgrade_service && ['x', 'X', '✓', '✔'].includes(row.upgrade_service.toString().trim())) {
                            statusValue = 'upgrade';
                        } 
                        // Fall back to the status column if no X is found
                        else if (row.status) {
                            if (row.status === 'Service en place' || row.status === 'existing') {
                                statusValue = 'existing';
                            } else if (row.status === 'Service à résilier' || row.status === 'replace') {
                                statusValue = 'replace';
                            } else if (row.status === 'Nouveau service' || row.status === 'new') {
                                statusValue = 'new';
                            } else if (row.status === 'Service à upgrader' || row.status === 'upgrade') {
                                statusValue = 'upgrade';
                            }
                        }
                        
                        const serviceWithCustomValues = {
                            ...serviceTemplate,
                            quantity: parseInt(row.quantity) || 1,
                            status: statusValue,
                            duration: "24"
                        };

                        if (row.abo_ht && row.abo_ht.toString().trim() !== '' && !isNaN(parseFloat(row.abo_ht.toString()))) {
                            serviceWithCustomValues.abo_ht = parseFloat(row.abo_ht.toString());
                        }

                        if (row.fas_ht && row.fas_ht.toString().trim() !== '' && !isNaN(parseFloat(row.fas_ht.toString()))) {     
                            serviceWithCustomValues.fas_ht = parseFloat(row.fas_ht.toString());
                        }

                        serviceTemplates.push(serviceWithCustomValues);
                    } else {
                        console.warn(`Service not found for solution: ${row.solution}`);
                        message.warning(`Service non trouvé: ${row.solution}`);
                    }
                }
            }

            if (serviceTemplates.length > 0) {
                await this.props.duplicateServices(serviceTemplates, [newSiteId]);
            }

            processedCount++;
            this.setState({
                batchProcessing: {
                    ...this.state.batchProcessing,
                    progress: Math.round((processedCount / totalSites) * 100)
                }
            });
        }
    };

    downloadExcelTemplate = () => {
        const template = Array(100).fill(null).map((_, index) => {
            if (index === 0) {
                return {
                    site_name: 'Example Site',
                    contact_name: 'John Doe',
                    contact_tel: '0123456789',
                    contact_mail: 'contact@example.com',
                    delivery_address: '123 Street Name, City',
                    siret: '12345678901234',
                    solution: 'INTERNET_FTTO-50M-ORANGE-Optimum- / 12 mois_(SE)',
                    abo_ht: '642',
                    fas_ht: '1231',
                    quantity: '1',
                    status: 'new',  // Keep original status column for compatibility
                    new_service: 'X',
                    existing_service: '',
                    replace_service: '',
                    upgrade_service: ''
                };
            }
            return {
                site_name: '',
                contact_name: '',
                contact_tel: '',
                contact_mail: '',
                delivery_address: '',
                siret: '',
                solution: '',
                abo_ht: '',
                fas_ht: '',
                quantity: '',
                status: '',
                new_service: '',
                existing_service: '',
                replace_service: '',
                upgrade_service: ''
            };
        });

        const ws = XLSX.utils.json_to_sheet(template);
        
        const columnWidths = [
            { wch: 15 }, // site_name
            { wch: 15 }, // contact_name
            { wch: 15 }, // contact_tel
            { wch: 25 }, // contact_mail
            { wch: 30 }, // delivery_address
            { wch: 15 }, // siret
            { wch: 50 }, // solution
            { wch: 15 }, // abo_ht
            { wch: 15 }, // fas_ht
            { wch: 10 }, // quantity
            { wch: 10 }, // status (hidden)
            { wch: 15 }, // new_service
            { wch: 15 }, // existing_service
            { wch: 15 }, // replace_service
            { wch: 15 }  // upgrade_service
        ];
        
        ws['!cols'] = columnWidths;
        
        // Add comments to explain how to use the status columns
        const newServiceComment = { 
            t: 'Marquez avec un "X" pour un nouveau service'
        };
        const existingServiceComment = { 
            t: 'Marquez avec un "X" pour un service existant'
        };
        const replaceServiceComment = { 
            t: 'Marquez avec un "X" pour un service à résilier'
        };
        const upgradeServiceComment = { 
            t: 'Marquez avec un "X" pour un service à upgrader'
        };
        if (!ws['!comments']) ws['!comments'] = {};
        ws['!comments'][XLSX.utils.encode_cell({ r: 0, c: 11 })] = newServiceComment;
        ws['!comments'][XLSX.utils.encode_cell({ r: 0, c: 12 })] = existingServiceComment;
        ws['!comments'][XLSX.utils.encode_cell({ r: 0, c: 13 })] = replaceServiceComment;
        ws['!comments'][XLSX.utils.encode_cell({ r: 0, c: 14 })] = upgradeServiceComment;
        // Hide the status column (it's only for internal use)
        const statusCell = XLSX.utils.encode_cell({ r: 0, c: 10 });
        if (!ws['!cols']) ws['!cols'] = [];
        ws['!cols'][10] = { hidden: true };
        
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Template");
        
        XLSX.writeFile(wb, "site_import_template.xlsx");
    };

    render() {
        const {disabledPdf} = this.state;
        const {selectedSites, selectedServices, dac_society_reducer} = this.props;
        const { numberOfSites, showSiteCreationPopover } = this.state;

        console.log("dac_society_reducer",dac_society_reducer);
        console.log("dacReducer",this.props.dacReducer);


        const siteCreationContent = (
            <div className="site-creation-popover">
                <div className="site-creation-inputs">
                    <InputNumber
                        min={1}
                        max={100}
                        value={numberOfSites}
                        onChange={this.handleNumberOfSitesChange}
                        style={{ width: '100px', marginRight: '8px' }}
                    />
                    <button 
                        onClick={this.handleAddMultipleSites}
                        className="confirm-sites-btn"
                    >
                        Confirmer
                    </button>
                </div>
            </div>
        );

        return (
            <div id={'ActionsDac'}>
                <div className={"disabled-ctn"}>
                    <input type={'text'} value={selectedSites.length} disabled/>
                    <label>Site selectionné</label>
                </div>
                <div className={"disabled-ctn"}>
                    <input type={'text'} value={selectedServices.length} disabled/>
                    <label>Service selectionné</label>
                </div>
                <div>
                    <input type="number" name={"discount_abo"} placeholder={`${dac_society_reducer.discount_abo}`}
                           onChange={this.editDiscount}/>
                    <label>Remise Abo (%)</label>
                </div>
                <Tooltip placement={'top'} title={
                    <div>
                        <div className={'d-flex ctn_mg'}>
                            <label className={'mr-3'}>Marge: </label>
                            <span> {this.margeTotal('abo')}€</span>
                        </div>
                        <div className={'d-flex  ctn_mg'}>
                            <label className={'mr-3'}>Marge taux: </label>
                            <span> {parseFloat(`${this.margeTaux('abo')}`).toFixed(2)}%</span>
                        </div>
                    </div>
                }>
                    <div className={"bg-green"}>
                        <input
                            type="text"
                            placeholder={`${Math.max(0, parseFloat(`${dac_society_reducer.abo_ht}`).toFixed(2))}`}
                            disabled
                        />
                        <label>Total Abo (€)</label>
                    </div>
                </Tooltip>
                <div>
                    <input type="number" name={"discount_fas"} placeholder={`${dac_society_reducer.discount_fas}`}
                           onChange={this.editDiscount}/>
                    <label>Remise Fas (%)</label>
                </div>

                <Tooltip placement={'top'} title={
                    <div>
                        <div className={'d-flex  ctn_mg'}>
                            <label className={'mr-3'}>Marge: </label>
                            <span> {this.margeTotal('fas')}€</span>
                        </div>
                        <div className={'d-flex ctn_mg'}>
                            <label className={'mr-3'}>Marge taux: </label>
                            <span> {parseFloat(`${this.margeTaux('fas')}`).toFixed(2)}%</span>
                        </div>
                    </div>
                }>
                    <div className={"bg-pink"}>
                        <input type="text" placeholder={`${parseFloat(`${dac_society_reducer.fas_ht}`).toFixed(2)}`}
                               disabled/>
                        <label>Total Fas (€)</label>
                    </div>
                </Tooltip>
                <div>
                    <SelectSearch actionReducer={(_: string, value: string) => this.setState(prevState => ({
                        ...prevState,
                        subscribe_duration: value
                    }))} items={this.props.durations} name={"subscribe_duration"}
                                  placeholder={'Duréee'}
                                  value={`${this.state.subscribe_duration}`}
                                  ctnName={"input__duree"}
                                  valuesDisplay={"label"} valuesKey={"id"} disableLabel={true}/>
                </div>
                <button onClick={(e) => this.props.addService(e, selectedSites)}><IconAdd/>
                    <span>Ajouter service</span>
                </button>
                {selectedServices.length > 0 &&
                    <>
                        {selectedSites.length > 0 &&
                            <button onClick={this.duplicateServices}><IconDuplicate/><span>Dupliquer service</span>
                            </button>
                        }
                        <button onClick={this.removeServices}><IconDelete/><span>Supprimer service</span></button>
                    </>
                }

                <Popover
                    content={siteCreationContent}
                    title="Nombre de sites à créer"
                    trigger="click"
                    open={showSiteCreationPopover}
                    onOpenChange={(visible) => this.setState({ showSiteCreationPopover: visible })}
                >
                    <button onClick={() => this.setState({ showSiteCreationPopover: true })}>
                        <IconAdd/>
                        <span>Ajouter site{numberOfSites > 1 ? `s (${numberOfSites})` : ''}</span>
                    </button>
                </Popover>

                {selectedSites.length > 0 &&
                    <>
                        <button onClick={this.duplicateSites}><IconDuplicate/><span>Dupliquer site</span></button>
                        <button onClick={this.removeSites}><IconDelete/><span>Supprimer site</span></button>
                    </>
                }
                {!disabledPdf ?
                    <PDFButton dataDac={this.props.dacReducer}/>
                    :
                    <button onClick={this.saveQuote}><FontAwesomeIcon icon={faSave}/> <span>Sauvegarder</span></button>
                }

                <Upload
                    beforeUpload={(file) => {
                        this.handleExcelUpload(file);
                        return false;
                    }}
                    accept=".xlsx,.xls"
                    showUploadList={false}
                >
                    <button>
                        <UploadOutlined />
                        <span>Importer Excel</span>
                    </button>
                </Upload>

                <button onClick={this.downloadExcelTemplate}>
                    <DownloadOutlined />
                    <span>Template Excel</span>
                </button>

                {this.renderBatchProcessingModal()}
                {this.renderServiceSelectionModal()}

            </div>
        )
    }
}

export default connector(ActionsDac);
